export const elementTypes = {
    group: "group",
    mediaOutputElement: "mediaOutputElement",
    signatureElement: "signatureElement",
    inputElement: "inputElement",
    documentationCharacteristic: "documentationCharacteristic",
    groupOfInspectionCharacteristics: "groupOfInspectionCharacteristics",
    groupOfInputElements: "groupOfInputElements"
};